module.exports = __webpack_public_path__ + "modules/platform/img/arrow-right-def.png";